import type { OrderCardData } from '@chewy/chat-library-common';
import { PaginatedSelector } from '@chewy/chat-library-components';
import Thumbnail from './Thumbnail';

const MAX_THUMBNAILS_PER_PAGE = 3;

interface ThumbnailSelectorProps {
  /**
   * Array of orders to display
   */
  data: Array<OrderCardData>;
  /**
   * Layout direction for the thumbnails
   * @default 'vertical'
   */
  direction?: 'horizontal' | 'vertical';
  /**
   * Additional CSS class name
   */
  className?: string;
  /**
   * Page offset for the thumbnails
   * @default 3
   */
  pageOffset?: number;
}

/**
 * Displays a list of selectable Thumbnails with pagination
 * Uses PaginatedSelector to handle pagination and action buttons
 */
export default function ThumbnailSelector({
  data,
  direction = 'vertical',
  className,
  pageOffset = MAX_THUMBNAILS_PER_PAGE,
}: ThumbnailSelectorProps) {
  return (
    <PaginatedSelector
      data={data}
      renderItem={(order) => (
        <Thumbnail key={order.orderId} data={order} />
      )}
      direction={direction}
      className={className}
      pageSize={pageOffset}
      itemType="order"
      showMoreAction={[{
        defaultAction: {
          type: 'button',
          text: 'Show More',
          payload: {
            action: 'SHOW_MORE_THUMBNAILS',
          },
        },
      }]}
      secondaryAction={[{
        defaultAction: {
          type: 'button',
          text: 'Need help with a different item',
          payload: {
            action: 'SHOW_DIFFERENT_THUMBNAILS_OPTIONS',
          },
        },
      }]}
    />
  );
}
